<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div>
        <topo-tree ref='topotree' :message="receiveGraphNeID" :searchBox='searchBox' :checkBox='checkBox' @sendInfo="receiveTreeMessage"></topo-tree>
      </div>
    </template>
    <template v-slot:right_view>
      <div>
        <button-graph ref='baseBtn' @notice='notice' :saveLocBtn='true' :layoutBtn='true' :selectAllBtn='true' :revertBtn='true' :fullScreenBtn='true' :backPreBtn='true' :refreshBtn='true'>
        </button-graph>
        <base-physic ref='baseObj' :nodes='nodes' :nodesMap="nodesMap" :message="receiveTreeNeID"
          @sendInfo="receiveGraphMessage" @updateTree='updateTreeData' @setTreeOnline='setTreeOnline'>
        </base-physic>
      </div>
    </template>
  </BasicLayout>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import BasicLayout from '../../../layouts/BasicLayout';
import TopoTree from '@/components/topoconfig/TopoTree';
import BasePhysic from '@/components/topoconfig/BasePhysic';
import ButtonGraph from '@/components/topoconfig/ButtonGraph';
import topoMethods from '@/components/topoconfig/TopoCommon';

const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

export default {
  name: 'physicGraph',
  components: {
    BasicLayout,
    TopoTree,
    ButtonGraph,
    BasePhysic,
  },

  mixins: [topoMethods],
  mounted() {
    window.onresize = () => {
      // 全屏状态下监听esc事件
      if (!this.checkFull()) {
        this.$parent.menuControl(0);
        this.flag = 1;
        this.$refs.baseBtn.flag = this.flag;
      }
    };
  },

  data() {
    return {
      left: {
        show: true,
        name: this.$t('Topo.elementTree'),
      },
      middle: {
        show: false,
        name: 'mo'
      },
      right: {
        show: true,
        crumb: this.$t('Topo.topoManagerAndTopoMonitor'),
      },

      searchBox: {
        show: true,
      },
      checkBox: {
        show: false,
      },
      receiveTreeNeID: '',
      receiveGraphNeID: '',
      nodes: [],
    };
  },
  computed: {
    ...mapGetters(['physicalNodes', 'logicalNodes', 'getTypeByCode', 'getTopoGraph']),
  },
  methods: {
    ...mapActions(['setPhysical', 'setLogical', 'setParentNe', 'addParentNe', 'delParentNe']),
    receiveTreeMessage(treeNeID) {
      this.receiveTreeNeID = treeNeID;
      this.$refs.baseObj.receiveTree(treeNeID);
      // this.$emit('sendInfo', treeNeID);
    },
    receiveGraphMessage(graphNeID) {
     this.receiveGraphNeID = graphNeID;
    //  this.$refs.topotree.message = graphNeID;
    },
    notice(type) {
      switch (type) {
        case 'saveLocBtn': // 保存位置
          this.saveLoc();
          break;
        case 'excelLayout': // 布局排序
          this.excelLayout();
          break;
        case 'revertScale': // 返回1:1
          this.revert();
          break;
        case 'fullScreen': // 全屏
          this.fullScreen();
          break;
        case 'selectAll': // 全选
          this.selectAll();
          break;
        case 'backPrevious': // 返回上级
          this.backPrevious();
          break;
        case 'refresh': // 刷新树和图
          this.refresh();
          break;
        default:
          break;
      }
    },
    saveLoc() {
      this.$refs.baseObj.saveLoc();
    },
    excelLayout() {
      this.$refs.baseObj.excelLayout();
    },
    revert() {
      this.$refs.baseObj.revert();
    },
    selectAll() {
      this.$refs.baseObj.selectAll();
    },
    backPrevious() {
      this.$refs.baseObj.backPrevious();
    },
    refresh() {
      // this.$refs.baseObj.loadElement();
      // this.$refs.topotree.getTopoTreeData();
      this.$refs.baseObj.refresh();
    },
    updateTreeData() {
      this.$refs.topotree.getTopoTreeData();
    },
 //   webSocket更新树状态
    setTreeOnline(id, isOnline) {
      this.$refs.topotree.setOnlineStatus(id, isOnline);
    }
  }
};
</script>

<style>
</style>
